export default {
    uponRequest: 'Upon Request',
    everyWeek: 'Every Week',
    everyTwoWeeks: 'Every Two Weeks',
    everyFourWeeks: 'Every Four Weeks',
    everySixWeeks: 'Every Six Weeks',
    everyEightWeeks: 'Every Eight Weeks',
    everyTwelveWeeks: 'Every Twelve Weeks',
    everySemester: 'Every Semester',
    everyYear: 'Every Year',
};
